module.exports = __webpack_public_path__ + "img/guarantee.7db25f23.svg";